var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.714,
    cy: 17.456,
    r: 1.501
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M32.625 12.376c1.72 1.96 2.23 4.8 2.23 4.8l3.52 1.23v5.56l-3.72 1.36s-.6 1.65-1.73 2.65c-1.15 1.03-2.59 1.68-2.59 1.68l-.64 3.41h-3.49l-.67-2.99h-8.84l-.66 2.99h-3.49l-.64-3.41s-2.93-2.04-3.97-3.76c-1.98-3.3-1.2-6.66-.71-8.46.22-.82-.12-1.7-.78-2.24l-2.3-1.9.8-1.61 3.79 1.28c.85.26 1.78.02 2.38-.65.76-.85 1.52-1.5 2.05-1.87 1.26-.88 2.64-1.62 5.33-2.07l-1.31 5.63 2.93 2.07 1.38 7.2 3.53-8.03-2.48-2.87 2.31-4.02c1.3.16 2.37.4 3.31.75h-.004l4.557-1.86-.093 5.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.764 19.421s-.527 3.912 2.951 5.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLiability);
export default __webpack_public_path__ + "static/media/otherLiability.070435774199f53e901c71c38aaa9098.svg";
export { ForwardRef as ReactComponent };